import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "swiper/swiper-bundle.css";
import "flatpickr/dist/flatpickr.css";
import App from "./App.tsx";
import { AppWrapper } from "./components/common/PageMeta.tsx";
import { ThemeProvider } from "./context/ThemeContext.tsx";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";
import { initializeGoogleAnalytics } from "./utils/analytics";
import "remixicon/fonts/remixicon.css";

// --- SENTRY CONFIG --- //
Sentry.init({
  dsn: "https://8c6292e7b9911a95bbb99a7528cc2538@o4509322734862336.ingest.us.sentry.io/4509322735976448",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration()
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.2,
  replaysOnErrorSampleRate: 0.2,
  sendDefaultPii: true,
  environment: import.meta.env.MODE,
  release: import.meta.env.VITE_SENTRY_RELEASE
});
// --- SENTRY CONFIG END --- //

// Inicializa o Google Analytics com configurações avançadas
initializeGoogleAnalytics('G-7XY72L8ZS7', {
  debug_mode: import.meta.env.DEV, // Ativa o modo de depuração em ambiente de desenvolvimento
  allow_google_signals: true,
  allow_ad_personalization_signals: true,
  cookie_expires: 63072000 // 2 anos em segundos (máximo permitido)
});

// Iniciar o rastreamento de desempenho da página
import { trackPagePerformance } from './utils/analytics';
trackPagePerformance();

// Crie um cliente React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1
    }
  }
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AppWrapper>
          <App />
        </AppWrapper>
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
);
